import { makeObservable, observable } from 'mobx';
import { persist } from 'mobx-persist';

export default class Person {
  id;
  lastname;
  firstname;
  email;

  constructor({ id, lastname = '', firstname = '', email = '' }) {
    persist('id')(this, 'id');
    persist('lastname')(this, 'lastname');
    persist('firstname')(this, 'firstname');
    persist('email')(this, 'email');

    this.id = id;
    this.lastname = lastname;
    this.firstname = firstname;
    this.email = email;

    makeObservable(this, {
      id: observable,
      lastname: observable,
      firstname: observable,
      email: observable
    });
  }
}
